module.exports = function(h, row) {
    let length = row.products.length;

    if (length < 1) {
        return <i>No products assigned</i>;
    }

    if (length === 1) {
        return row.products[0].name;
    }

    return <i>Assigned to {length} products</i>;
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/modifier/vuetablemodifier_items.jsx